import classNames from 'classnames';
import classes from './FlexBetweenItem.module.scss';

function FlexBetweenItem({ className, center, children, ...props }) {
    return (
        <div
            className={classNames(classes.flexBetween, center && classes.alignCenter, className)}
            {...props}
        >
            {children}
        </div>
    );
}
export default FlexBetweenItem;
